import { SubButton } from '@/common/buttons/SubButton';
import { ConfigForm } from '@/common/entities/config/ConfigForm';
import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityFormMode } from '@/common/entityFramework/enumerations/EntityFormMode';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ValList } from '@/common/val/ValList';
import { JobList } from '@/skdr/entities/job/JobList';
import { useEffect } from 'react';

export const OrgDetail = () => {
  const { entityObj, setEntityFormMode } = useEntityMgr();
  const { navState, assign } = useNavState();
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  // Fetch to get the Org's ID
  useEffect(() => {
    if (navState.entityId) return;
    rsrc.one(module, 'ORG', {}).then((org) => {
      assign('entityId', org.id);
      setEntityFormMode(EntityFormMode.VIEW);
    });
  }, [navState.entityId]);

  if (!navState.entityId) {
    return null;
  }

  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    {
      id: 'config',
      label: 'Configuration',
      content: <ConfigForm entityId={entityObj.configId} parentOrgId={entityObj.id} />,
    },
    {
      id: 'prop',
      label: 'Properties',
      content: <EntityPropList parentEntity="ORG" parentEntityObj={entityObj} />,
    },
    {
      id: 'validation',
      label: 'Configuration Validations',
      content: <ValList parentEntity="CONFIG" parentEntityId={entityObj.configId} />,
    },
  ];

  if (module === 'skdr') {
    tabSpecs.splice(2, 0, {
      id: 'job',
      label: 'Jobs',
      content: <JobList chain />,
    });
  }

  const augButtons = (buttons) => {
    buttons.push(<SubButton />);
  };

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />;
};
